import { Box } from "@material-ui/core";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { RecoilState } from "recoil";
import { useMapThemeClasses } from "../../hooks/use-map-theme-styles";
import Card from "../Card";
import TabsComponent from "./TabsComponent";

export interface TabItem {
	id?: string;
	label: string;
	component: JSX.Element;
	isTabDisabled?: boolean;
	tooltip?: string | JSX.Element;
	tabContainerStyles?: CSSProperties | undefined;
	TabIcon?: JSX.Element;
	propStyles?: any;
}

interface IProps {
	tabState: RecoilState<any>;
	activeTabProp?: number;
	noCardWrap?: boolean;
	useUrlTab?: boolean; //flags if we want to manage active tabs via url query param 'tab'
	bottomMargin?: number;
	onTabClick?: (tab: number) => void;
	tabs: Array<TabItem>;
	noShadow?: boolean;
	flex?: boolean;
}

export default function LyfeTabs(props: IProps) {
	const { tabContainer, paper } = useMapThemeClasses();

	return !props.noCardWrap ? (
		<Card
			classes={{ root: paper }}
			className={tabContainer}
			style={{
				marginBottom: props.bottomMargin,
				boxShadow: props.noShadow ? "none" : undefined,
			}}
		>
			{" "}
			<TabsComponent {...props} />
		</Card>
	) : (
		<Box
			className={tabContainer}
			style={{
				marginBottom: props.bottomMargin,
				boxShadow: props.noShadow ? "none" : undefined,
				...(props.flex ? { display: "flex", flexDirection: "column", flexGrow: 1, marginBottom: 0 } : {}),
			}}
		>
			<TabsComponent {...props} />
		</Box>
	);
}
